import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLWorkingHoursClient, OverrideWorkingHoursModel, WorkingHoursModel } from "./api/cplapi/CPLAPI";
import { inject, injectable } from "inversify";

export interface IWorkingHoursService {
  getStandardWorkingHours(): Promise<WorkingHoursModel[]>;
  updateStandardWorkingHours(workingHours: WorkingHoursModel): Promise<void>;
  getOverrideWorkingHours(): Promise<OverrideWorkingHoursModel[]>;
  createOverrideWorkingHours(overrideWorkingHours: OverrideWorkingHoursModel): Promise<void>;
  updateOverrideWorkingHours(overrideWorkingHours: OverrideWorkingHoursModel): Promise<void>;
  deleteOverrideWorkingHours(overrideWorkingHoursID: number): Promise<void>;
}

@injectable()
export class WorkingHoursService implements IWorkingHoursService {
  @inject(SERVICE_TYPES.CPLWorkingHoursClient) cplWorkingHoursClient!: ICPLWorkingHoursClient;

  async getStandardWorkingHours(): Promise<WorkingHoursModel[]> {
    return this.cplWorkingHoursClient.getStandardWorkingHours();
  }

  async updateStandardWorkingHours(workingHours: WorkingHoursModel): Promise<void> {
    return this.cplWorkingHoursClient.updateStandardWorkingHours(workingHours);
  }

  async getOverrideWorkingHours(): Promise<OverrideWorkingHoursModel[]> {
    return this.cplWorkingHoursClient.getOverrideWorkingHours();
  }

  async createOverrideWorkingHours(overrideWorkingHours: OverrideWorkingHoursModel): Promise<void> {
    return this.cplWorkingHoursClient.createOverrideWorkingHours(overrideWorkingHours);
  }

  async updateOverrideWorkingHours(overrideWorkingHours: OverrideWorkingHoursModel): Promise<void> {
    return this.cplWorkingHoursClient.updateOverrideWorkingHours(overrideWorkingHours);
  }

  async deleteOverrideWorkingHours(overrideWorkingHoursID: number): Promise<void> {
    return this.cplWorkingHoursClient.deleteOverrideWorkingHours(overrideWorkingHoursID);
  }
}
